import React from 'react';
import { M } from '@dashboard-experience/mastodon';
import T from 'components/T';
import useT from 'hooks/useT';

interface ErrorPanelProps {
  componentName: string;
}

const ErrorPanel: React.FC<ErrorPanelProps> = ({ componentName }) => {
  const { t } = useT();
  return (
    <M.ActionableNotification
      kind='error'
      title={t(`components.${componentName}.Error.title`)}
      subtitle={
        <T value={`components.${componentName}.Error.message`} dangerousHTML />
      }
      hideCloseButton
      inline
      closeOnEscape={false}
      hasFocus={false}
      style={{ maxWidth: '100%' }}
    />
  );
};

export default ErrorPanel;
